//NHL Account AppMeasurement.js
//RENAME TO AppMeasurement.js
//updated Oct 18, 2016 by kwestern
/*
 ============== DO NOT ALTER ANYTHING BELOW THIS LINE ! ===============

AppMeasurement for JavaScript version: 1.7.0
Copyright 1996-2016 Adobe, Inc. All Rights Reserved
More info available at http://www.adobe.com/marketing-cloud.html
*/
window.AppMeasurement = function () {
    var a = this;
    a.version = '1.7.0';
    var k = window;
    k.s_c_in || ((k.s_c_il = []), (k.s_c_in = 0));
    a._il = k.s_c_il;
    a._in = k.s_c_in;
    a._il[a._in] = a;
    k.s_c_in++;
    a._c = 's_c';
    var q = k.AppMeasurement.Jb;
    q || (q = null);
    var r = k,
        n,
        t;
    try {
        for (
            n = r.parent, t = r.location;
            n &&
            n.location &&
            t &&
            '' + n.location != '' + t &&
            r.location &&
            '' + n.location != '' + r.location &&
            n.location.host == t.host;

        )
            (r = n), (n = r.parent);
    } catch (u) {}
    a.yb = function (a) {
        try {
            console.log(a);
        } catch (b) {}
    };
    a.Ha = function (a) {
        return '' + parseInt(a) == '' + a;
    };
    a.replace = function (a, b, d) {
        return !a || 0 > a.indexOf(b) ? a : a.split(b).join(d);
    };
    a.escape = function (c) {
        var b, d;
        if (!c) return c;
        c = encodeURIComponent(c);
        for (b = 0; 7 > b; b++)
            (d = "+~!*()'".substring(b, b + 1)),
                0 <= c.indexOf(d) && (c = a.replace(c, d, '%' + d.charCodeAt(0).toString(16).toUpperCase()));
        return c;
    };
    a.unescape = function (c) {
        if (!c) return c;
        c = 0 <= c.indexOf('+') ? a.replace(c, '+', ' ') : c;
        try {
            return decodeURIComponent(c);
        } catch (b) {}
        return unescape(c);
    };
    a.pb = function () {
        var c = k.location.hostname,
            b = a.fpCookieDomainPeriods,
            d;
        b || (b = a.cookieDomainPeriods);
        if (
            c &&
            !a.cookieDomain &&
            !/^[0-9.]+$/.test(c) &&
            ((b = b ? parseInt(b) : 2), (b = 2 < b ? b : 2), (d = c.lastIndexOf('.')), 0 <= d)
        ) {
            for (; 0 <= d && 1 < b; ) (d = c.lastIndexOf('.', d - 1)), b--;
            a.cookieDomain = 0 < d ? c.substring(d) : c;
        }
        return a.cookieDomain;
    };
    a.c_r = a.cookieRead = function (c) {
        c = a.escape(c);
        var b = ' ' + a.d.cookie,
            d = b.indexOf(' ' + c + '='),
            f = 0 > d ? d : b.indexOf(';', d);
        c = 0 > d ? '' : a.unescape(b.substring(d + 2 + c.length, 0 > f ? b.length : f));
        return '[[B]]' != c ? c : '';
    };
    a.c_w = a.cookieWrite = function (c, b, d) {
        var f = a.pb(),
            e = a.cookieLifetime,
            g;
        b = '' + b;
        e = e ? ('' + e).toUpperCase() : '';
        d &&
            'SESSION' != e &&
            'NONE' != e &&
            ((g = '' != b ? parseInt(e ? e : 0) : -60)
                ? ((d = new Date()), d.setTime(d.getTime() + 1e3 * g))
                : 1 == d && ((d = new Date()), (g = d.getYear()), d.setYear(g + 5 + (1900 > g ? 1900 : 0))));
        return c && 'NONE' != e
            ? ((a.d.cookie =
                  a.escape(c) +
                  '=' +
                  a.escape('' != b ? b : '[[B]]') +
                  '; path=/;' +
                  (d && 'SESSION' != e ? ' expires=' + d.toGMTString() + ';' : '') +
                  (f ? ' domain=' + f + ';' : '')),
              a.cookieRead(c) == b)
            : 0;
    };
    a.K = [];
    a.ha = function (c, b, d) {
        if (a.Aa) return 0;
        a.maxDelay || (a.maxDelay = 250);
        var f = 0,
            e = new Date().getTime() + a.maxDelay,
            g = a.d.visibilityState,
            m = ['webkitvisibilitychange', 'visibilitychange'];
        g || (g = a.d.webkitVisibilityState);
        if (g && 'prerender' == g) {
            if (!a.ia)
                for (a.ia = 1, d = 0; d < m.length; d++)
                    a.d.addEventListener(m[d], function () {
                        var b = a.d.visibilityState;
                        b || (b = a.d.webkitVisibilityState);
                        'visible' == b && ((a.ia = 0), a.delayReady());
                    });
            f = 1;
            e = 0;
        } else d || (a.p('_d') && (f = 1));
        f && (a.K.push({ m: c, a: b, t: e }), a.ia || setTimeout(a.delayReady, a.maxDelay));
        return f;
    };
    a.delayReady = function () {
        var c = new Date().getTime(),
            b = 0,
            d;
        for (a.p('_d') ? (b = 1) : a.va(); 0 < a.K.length; ) {
            d = a.K.shift();
            if (b && !d.t && d.t > c) {
                a.K.unshift(d);
                setTimeout(a.delayReady, parseInt(a.maxDelay / 2));
                break;
            }
            a.Aa = 1;
            a[d.m].apply(a, d.a);
            a.Aa = 0;
        }
    };
    a.setAccount = a.sa = function (c) {
        var b, d;
        if (!a.ha('setAccount', arguments))
            if (((a.account = c), a.allAccounts))
                for (b = a.allAccounts.concat(c.split(',')), a.allAccounts = [], b.sort(), d = 0; d < b.length; d++)
                    (0 != d && b[d - 1] == b[d]) || a.allAccounts.push(b[d]);
            else a.allAccounts = c.split(',');
    };
    a.foreachVar = function (c, b) {
        var d,
            f,
            e,
            g,
            m = '';
        e = f = '';
        if (a.lightProfileID) (d = a.O), (m = a.lightTrackVars) && (m = ',' + m + ',' + a.ma.join(',') + ',');
        else {
            d = a.g;
            if (a.pe || a.linkType)
                (m = a.linkTrackVars),
                    (f = a.linkTrackEvents),
                    a.pe &&
                        ((e = a.pe.substring(0, 1).toUpperCase() + a.pe.substring(1)),
                        a[e] && ((m = a[e].Hb), (f = a[e].Gb)));
            m && (m = ',' + m + ',' + a.G.join(',') + ',');
            f && m && (m += ',events,');
        }
        b && (b = ',' + b + ',');
        for (f = 0; f < d.length; f++)
            (e = d[f]),
                (g = a[e]) && (!m || 0 <= m.indexOf(',' + e + ',')) && (!b || 0 <= b.indexOf(',' + e + ',')) && c(e, g);
    };
    a.r = function (c, b, d, f, e) {
        var g = '',
            m,
            p,
            k,
            w,
            n = 0;
        'contextData' == c && (c = 'c');
        if (b) {
            for (m in b)
                if (
                    !(Object.prototype[m] || (e && m.substring(0, e.length) != e)) &&
                    b[m] &&
                    (!d || 0 <= d.indexOf(',' + (f ? f + '.' : '') + m + ','))
                ) {
                    k = !1;
                    if (n) for (p = 0; p < n.length; p++) m.substring(0, n[p].length) == n[p] && (k = !0);
                    if (
                        !k &&
                        ('' == g && (g += '&' + c + '.'), (p = b[m]), e && (m = m.substring(e.length)), 0 < m.length)
                    )
                        if (((k = m.indexOf('.')), 0 < k))
                            (p = m.substring(0, k)),
                                (k = (e ? e : '') + p + '.'),
                                n || (n = []),
                                n.push(k),
                                (g += a.r(p, b, d, f, k));
                        else if (('boolean' == typeof p && (p = p ? 'true' : 'false'), p)) {
                            if ('retrieveLightData' == f && 0 > e.indexOf('.contextData.'))
                                switch (((k = m.substring(0, 4)), (w = m.substring(4)), m)) {
                                    case 'transactionID':
                                        m = 'xact';
                                        break;
                                    case 'channel':
                                        m = 'ch';
                                        break;
                                    case 'campaign':
                                        m = 'v0';
                                        break;
                                    default:
                                        a.Ha(w) &&
                                            ('prop' == k
                                                ? (m = 'c' + w)
                                                : 'eVar' == k
                                                  ? (m = 'v' + w)
                                                  : 'list' == k
                                                    ? (m = 'l' + w)
                                                    : 'hier' == k && ((m = 'h' + w), (p = p.substring(0, 255))));
                                }
                            g += '&' + a.escape(m) + '=' + a.escape(p);
                        }
                }
            '' != g && (g += '&.' + c);
        }
        return g;
    };
    a.usePostbacks = 0;
    a.sb = function () {
        var c = '',
            b,
            d,
            f,
            e,
            g,
            m,
            p,
            k,
            n = '',
            r = '',
            s = (e = '');
        if (a.lightProfileID) (b = a.O), (n = a.lightTrackVars) && (n = ',' + n + ',' + a.ma.join(',') + ',');
        else {
            b = a.g;
            if (a.pe || a.linkType)
                (n = a.linkTrackVars),
                    (r = a.linkTrackEvents),
                    a.pe &&
                        ((e = a.pe.substring(0, 1).toUpperCase() + a.pe.substring(1)),
                        a[e] && ((n = a[e].Hb), (r = a[e].Gb)));
            n && (n = ',' + n + ',' + a.G.join(',') + ',');
            r && ((r = ',' + r + ','), n && (n += ',events,'));
            a.events2 && (s += ('' != s ? ',' : '') + a.events2);
        }
        if (a.visitor && 1.5 <= parseFloat(a.visitor.version) && a.visitor.getCustomerIDs) {
            e = q;
            if ((g = a.visitor.getCustomerIDs()))
                for (d in g)
                    Object.prototype[d] ||
                        ((f = g[d]),
                        e || (e = {}),
                        f.id && (e[d + '.id'] = f.id),
                        f.authState && (e[d + '.as'] = f.authState));
            e && (c += a.r('cid', e));
        }
        a.AudienceManagement &&
            a.AudienceManagement.isReady() &&
            (c += a.r('d', a.AudienceManagement.getEventCallConfigParams()));
        for (d = 0; d < b.length; d++) {
            e = b[d];
            g = a[e];
            f = e.substring(0, 4);
            m = e.substring(4);
            !g && 'events' == e && s && ((g = s), (s = ''));
            if (g && (!n || 0 <= n.indexOf(',' + e + ','))) {
                switch (e) {
                    case 'supplementalDataID':
                        e = 'sdid';
                        break;
                    case 'timestamp':
                        e = 'ts';
                        break;
                    case 'dynamicVariablePrefix':
                        e = 'D';
                        break;
                    case 'visitorID':
                        e = 'vid';
                        break;
                    case 'marketingCloudVisitorID':
                        e = 'mid';
                        break;
                    case 'analyticsVisitorID':
                        e = 'aid';
                        break;
                    case 'audienceManagerLocationHint':
                        e = 'aamlh';
                        break;
                    case 'audienceManagerBlob':
                        e = 'aamb';
                        break;
                    case 'authState':
                        e = 'as';
                        break;
                    case 'pageURL':
                        e = 'g';
                        255 < g.length && ((a.pageURLRest = g.substring(255)), (g = g.substring(0, 255)));
                        break;
                    case 'pageURLRest':
                        e = '-g';
                        break;
                    case 'referrer':
                        e = 'r';
                        break;
                    case 'vmk':
                    case 'visitorMigrationKey':
                        e = 'vmt';
                        break;
                    case 'visitorMigrationServer':
                        e = 'vmf';
                        a.ssl && a.visitorMigrationServerSecure && (g = '');
                        break;
                    case 'visitorMigrationServerSecure':
                        e = 'vmf';
                        !a.ssl && a.visitorMigrationServer && (g = '');
                        break;
                    case 'charSet':
                        e = 'ce';
                        break;
                    case 'visitorNamespace':
                        e = 'ns';
                        break;
                    case 'cookieDomainPeriods':
                        e = 'cdp';
                        break;
                    case 'cookieLifetime':
                        e = 'cl';
                        break;
                    case 'variableProvider':
                        e = 'vvp';
                        break;
                    case 'currencyCode':
                        e = 'cc';
                        break;
                    case 'channel':
                        e = 'ch';
                        break;
                    case 'transactionID':
                        e = 'xact';
                        break;
                    case 'campaign':
                        e = 'v0';
                        break;
                    case 'latitude':
                        e = 'lat';
                        break;
                    case 'longitude':
                        e = 'lon';
                        break;
                    case 'resolution':
                        e = 's';
                        break;
                    case 'colorDepth':
                        e = 'c';
                        break;
                    case 'javascriptVersion':
                        e = 'j';
                        break;
                    case 'javaEnabled':
                        e = 'v';
                        break;
                    case 'cookiesEnabled':
                        e = 'k';
                        break;
                    case 'browserWidth':
                        e = 'bw';
                        break;
                    case 'browserHeight':
                        e = 'bh';
                        break;
                    case 'connectionType':
                        e = 'ct';
                        break;
                    case 'homepage':
                        e = 'hp';
                        break;
                    case 'events':
                        s && (g += ('' != g ? ',' : '') + s);
                        if (r)
                            for (m = g.split(','), g = '', f = 0; f < m.length; f++)
                                (p = m[f]),
                                    (k = p.indexOf('=')),
                                    0 <= k && (p = p.substring(0, k)),
                                    (k = p.indexOf(':')),
                                    0 <= k && (p = p.substring(0, k)),
                                    0 <= r.indexOf(',' + p + ',') && (g += (g ? ',' : '') + m[f]);
                        break;
                    case 'events2':
                        g = '';
                        break;
                    case 'contextData':
                        c += a.r('c', a[e], n, e);
                        g = '';
                        break;
                    case 'lightProfileID':
                        e = 'mtp';
                        break;
                    case 'lightStoreForSeconds':
                        e = 'mtss';
                        a.lightProfileID || (g = '');
                        break;
                    case 'lightIncrementBy':
                        e = 'mti';
                        a.lightProfileID || (g = '');
                        break;
                    case 'retrieveLightProfiles':
                        e = 'mtsr';
                        break;
                    case 'deleteLightProfiles':
                        e = 'mtsd';
                        break;
                    case 'retrieveLightData':
                        a.retrieveLightProfiles && (c += a.r('mts', a[e], n, e));
                        g = '';
                        break;
                    default:
                        a.Ha(m) &&
                            ('prop' == f
                                ? (e = 'c' + m)
                                : 'eVar' == f
                                  ? (e = 'v' + m)
                                  : 'list' == f
                                    ? (e = 'l' + m)
                                    : 'hier' == f && ((e = 'h' + m), (g = g.substring(0, 255))));
                }
                g && (c += '&' + e + '=' + ('pev' != e.substring(0, 3) ? a.escape(g) : g));
            }
            'pev3' == e && a.e && (c += a.e);
        }
        return c;
    };
    a.D = function (a) {
        var b = a.tagName;
        if ('undefined' != '' + a.Mb || ('undefined' != '' + a.Cb && 'HTML' != ('' + a.Cb).toUpperCase())) return '';
        b = b && b.toUpperCase ? b.toUpperCase() : '';
        'SHAPE' == b && (b = '');
        b &&
            (('INPUT' == b || 'BUTTON' == b) && a.type && a.type.toUpperCase
                ? (b = a.type.toUpperCase())
                : !b && a.href && (b = 'A'));
        return b;
    };
    a.Da = function (a) {
        var b = a.href ? a.href : '',
            d,
            f,
            e;
        d = b.indexOf(':');
        f = b.indexOf('?');
        e = b.indexOf('/');
        b &&
            (0 > d || (0 <= f && d > f) || (0 <= e && d > e)) &&
            ((f = a.protocol && 1 < a.protocol.length ? a.protocol : l.protocol ? l.protocol : ''),
            (d = l.pathname.lastIndexOf('/')),
            (b =
                (f ? f + '//' : '') +
                (a.host ? a.host : l.host ? l.host : '') +
                ('/' != h.substring(0, 1) ? l.pathname.substring(0, 0 > d ? 0 : d) + '/' : '') +
                b));
        return b;
    };
    a.L = function (c) {
        var b = a.D(c),
            d,
            f,
            e = '',
            g = 0;
        return b &&
            ((d = c.protocol),
            (f = c.onclick),
            !c.href || ('A' != b && 'AREA' != b) || (f && d && !(0 > d.toLowerCase().indexOf('javascript')))
                ? f
                    ? ((e = a.replace(a.replace(a.replace(a.replace('' + f, '\r', ''), '\n', ''), '\t', ''), ' ', '')),
                      (g = 2))
                    : 'INPUT' == b || 'SUBMIT' == b
                      ? (c.value
                            ? (e = c.value)
                            : c.innerText
                              ? (e = c.innerText)
                              : c.textContent && (e = c.textContent),
                        (g = 3))
                      : 'IMAGE' == b && c.src && (e = c.src)
                : (e = a.Da(c)),
            e)
            ? { id: e.substring(0, 100), type: g }
            : 0;
    };
    a.Kb = function (c) {
        for (var b = a.D(c), d = a.L(c); c && !d && 'BODY' != b; )
            if ((c = c.parentElement ? c.parentElement : c.parentNode)) (b = a.D(c)), (d = a.L(c));
        (d && 'BODY' != b) || (c = 0);
        c &&
            ((b = c.onclick ? '' + c.onclick : ''), 0 <= b.indexOf('.tl(') || 0 <= b.indexOf('.trackLink(')) &&
            (c = 0);
        return c;
    };
    a.Bb = function () {
        var c,
            b,
            d = a.linkObject,
            f = a.linkType,
            e = a.linkURL,
            g,
            m;
        a.na = 1;
        d || ((a.na = 0), (d = a.clickObject));
        if (d) {
            c = a.D(d);
            for (b = a.L(d); d && !b && 'BODY' != c; )
                if ((d = d.parentElement ? d.parentElement : d.parentNode)) (c = a.D(d)), (b = a.L(d));
            (b && 'BODY' != c) || (d = 0);
            if (d && !a.linkObject) {
                var p = d.onclick ? '' + d.onclick : '';
                if (0 <= p.indexOf('.tl(') || 0 <= p.indexOf('.trackLink(')) d = 0;
            }
        } else a.na = 1;
        !e && d && (e = a.Da(d));
        e && !a.linkLeaveQueryString && ((g = e.indexOf('?')), 0 <= g && (e = e.substring(0, g)));
        if (!f && e) {
            var n = 0,
                r = 0,
                q;
            if (a.trackDownloadLinks && a.linkDownloadFileTypes)
                for (
                    p = e.toLowerCase(),
                        g = p.indexOf('?'),
                        m = p.indexOf('#'),
                        0 <= g ? 0 <= m && m < g && (g = m) : (g = m),
                        0 <= g && (p = p.substring(0, g)),
                        g = a.linkDownloadFileTypes.toLowerCase().split(','),
                        m = 0;
                    m < g.length;
                    m++
                )
                    (q = g[m]) && p.substring(p.length - (q.length + 1)) == '.' + q && (f = 'd');
            if (
                a.trackExternalLinks &&
                !f &&
                ((p = e.toLowerCase()),
                a.Ga(p) &&
                    (a.linkInternalFilters || (a.linkInternalFilters = k.location.hostname),
                    (g = 0),
                    a.linkExternalFilters
                        ? ((g = a.linkExternalFilters.toLowerCase().split(',')), (n = 1))
                        : a.linkInternalFilters && (g = a.linkInternalFilters.toLowerCase().split(',')),
                    g))
            ) {
                for (m = 0; m < g.length; m++) (q = g[m]), 0 <= p.indexOf(q) && (r = 1);
                r ? n && (f = 'e') : n || (f = 'e');
            }
        }
        a.linkObject = d;
        a.linkURL = e;
        a.linkType = f;
        if (a.trackClickMap || a.trackInlineStats)
            (a.e = ''),
                d &&
                    ((f = a.pageName),
                    (e = 1),
                    (d = d.sourceIndex),
                    f || ((f = a.pageURL), (e = 0)),
                    k.s_objectID && ((b.id = k.s_objectID), (d = b.type = 1)),
                    f &&
                        b &&
                        b.id &&
                        c &&
                        (a.e =
                            '&pid=' +
                            a.escape(f.substring(0, 255)) +
                            (e ? '&pidt=' + e : '') +
                            '&oid=' +
                            a.escape(b.id.substring(0, 100)) +
                            (b.type ? '&oidt=' + b.type : '') +
                            '&ot=' +
                            c +
                            (d ? '&oi=' + d : '')));
    };
    a.tb = function () {
        var c = a.na,
            b = a.linkType,
            d = a.linkURL,
            f = a.linkName;
        b &&
            (d || f) &&
            ((b = b.toLowerCase()),
            'd' != b && 'e' != b && (b = 'o'),
            (a.pe = 'lnk_' + b),
            (a.pev1 = d ? a.escape(d) : ''),
            (a.pev2 = f ? a.escape(f) : ''),
            (c = 1));
        a.abort && (c = 0);
        if (a.trackClickMap || a.trackInlineStats || a.ActivityMap) {
            var b = {},
                d = 0,
                e = a.cookieRead('s_sq'),
                g = e ? e.split('&') : 0,
                m,
                p,
                k,
                e = 0;
            if (g)
                for (m = 0; m < g.length; m++)
                    (p = g[m].split('=')), (f = a.unescape(p[0]).split(',')), (p = a.unescape(p[1])), (b[p] = f);
            f = a.account.split(',');
            m = {};
            for (k in a.contextData)
                k &&
                    !Object.prototype[k] &&
                    'a.activitymap.' == k.substring(0, 14) &&
                    ((m[k] = a.contextData[k]), (a.contextData[k] = ''));
            a.e = a.r('c', m) + (a.e ? a.e : '');
            if (c || a.e) {
                c && !a.e && (e = 1);
                for (p in b)
                    if (!Object.prototype[p])
                        for (k = 0; k < f.length; k++)
                            for (
                                e &&
                                    ((g = b[p].join(',')),
                                    g == a.account &&
                                        ((a.e += ('&' != p.charAt(0) ? '&' : '') + p), (b[p] = []), (d = 1))),
                                    m = 0;
                                m < b[p].length;
                                m++
                            )
                                (g = b[p][m]),
                                    g == f[k] &&
                                        (e &&
                                            (a.e += '&u=' + a.escape(g) + ('&' != p.charAt(0) ? '&' : '') + p + '&u=0'),
                                        b[p].splice(m, 1),
                                        (d = 1));
                c || (d = 1);
                if (d) {
                    e = '';
                    m = 2;
                    !c && a.e && ((e = a.escape(f.join(',')) + '=' + a.escape(a.e)), (m = 1));
                    for (p in b)
                        !Object.prototype[p] &&
                            0 < m &&
                            0 < b[p].length &&
                            ((e += (e ? '&' : '') + a.escape(b[p].join(',')) + '=' + a.escape(p)), m--);
                    a.cookieWrite('s_sq', e);
                }
            }
        }
        return c;
    };
    a.ub = function () {
        if (!a.Fb) {
            var c = new Date(),
                b = r.location,
                d,
                f,
                e = (f = d = ''),
                g = '',
                m = '',
                k = '1.2',
                n = a.cookieWrite('s_cc', 'true', 0) ? 'Y' : 'N',
                q = '',
                s = '';
            if (c.setUTCDate && ((k = '1.3'), (0).toPrecision && ((k = '1.5'), (c = []), c.forEach))) {
                k = '1.6';
                f = 0;
                d = {};
                try {
                    (f = new Iterator(d)),
                        f.next &&
                            ((k = '1.7'),
                            c.reduce &&
                                ((k = '1.8'),
                                k.trim &&
                                    ((k = '1.8.1'), Date.parse && ((k = '1.8.2'), Object.create && (k = '1.8.5')))));
                } catch (t) {}
            }
            d = screen.width + 'x' + screen.height;
            e = navigator.javaEnabled() ? 'Y' : 'N';
            f = screen.pixelDepth ? screen.pixelDepth : screen.colorDepth;
            g = a.w.innerWidth ? a.w.innerWidth : a.d.documentElement.offsetWidth;
            m = a.w.innerHeight ? a.w.innerHeight : a.d.documentElement.offsetHeight;
            try {
                a.b.addBehavior('#default#homePage'), (q = a.b.Lb(b) ? 'Y' : 'N');
            } catch (u) {}
            try {
                a.b.addBehavior('#default#clientCaps'), (s = a.b.connectionType);
            } catch (x) {}
            a.resolution = d;
            a.colorDepth = f;
            a.javascriptVersion = k;
            a.javaEnabled = e;
            a.cookiesEnabled = n;
            a.browserWidth = g;
            a.browserHeight = m;
            a.connectionType = s;
            a.homepage = q;
            a.Fb = 1;
        }
    };
    a.P = {};
    a.loadModule = function (c, b) {
        var d = a.P[c];
        if (!d) {
            d = k['AppMeasurement_Module_' + c] ? new k['AppMeasurement_Module_' + c](a) : {};
            a.P[c] = a[c] = d;
            d.Xa = function () {
                return d.ab;
            };
            d.bb = function (b) {
                if ((d.ab = b)) (a[c + '_onLoad'] = b), a.ha(c + '_onLoad', [a, d], 1) || b(a, d);
            };
            try {
                Object.defineProperty ? Object.defineProperty(d, 'onLoad', { get: d.Xa, set: d.bb }) : (d._olc = 1);
            } catch (f) {
                d._olc = 1;
            }
        }
        b && ((a[c + '_onLoad'] = b), a.ha(c + '_onLoad', [a, d], 1) || b(a, d));
    };
    a.p = function (c) {
        var b, d;
        for (b in a.P)
            if (
                !Object.prototype[b] &&
                (d = a.P[b]) &&
                (d._olc && d.onLoad && ((d._olc = 0), d.onLoad(a, d)), d[c] && d[c]())
            )
                return 1;
        return 0;
    };
    a.wb = function () {
        var c = Math.floor(1e13 * Math.random()),
            b = a.visitorSampling,
            d = a.visitorSamplingGroup,
            d = 's_vsn_' + (a.visitorNamespace ? a.visitorNamespace : a.account) + (d ? '_' + d : ''),
            f = a.cookieRead(d);
        if (b) {
            f && (f = parseInt(f));
            if (!f) {
                if (!a.cookieWrite(d, c)) return 0;
                f = c;
            }
            if (f % 1e4 > v) return 0;
        }
        return 1;
    };
    a.Q = function (c, b) {
        var d, f, e, g, m, k;
        for (d = 0; 2 > d; d++)
            for (f = 0 < d ? a.wa : a.g, e = 0; e < f.length; e++)
                if (((g = f[e]), (m = c[g]) || c['!' + g])) {
                    if (!b && ('contextData' == g || 'retrieveLightData' == g) && a[g])
                        for (k in a[g]) m[k] || (m[k] = a[g][k]);
                    a[g] = m;
                }
    };
    a.Qa = function (c, b) {
        var d, f, e, g;
        for (d = 0; 2 > d; d++)
            for (f = 0 < d ? a.wa : a.g, e = 0; e < f.length; e++)
                (g = f[e]), (c[g] = a[g]), b || c[g] || (c['!' + g] = 1);
    };
    a.ob = function (a) {
        var b,
            d,
            f,
            e,
            g,
            k = 0,
            p,
            n = '',
            q = '';
        if (
            a &&
            255 < a.length &&
            ((b = '' + a),
            (d = b.indexOf('?')),
            0 < d &&
                ((p = b.substring(d + 1)),
                (b = b.substring(0, d)),
                (e = b.toLowerCase()),
                (f = 0),
                'http://' == e.substring(0, 7) ? (f += 7) : 'https://' == e.substring(0, 8) && (f += 8),
                (d = e.indexOf('/', f)),
                0 < d &&
                    ((e = e.substring(f, d)),
                    (g = b.substring(d)),
                    (b = b.substring(0, d)),
                    0 <= e.indexOf('google')
                        ? (k = ',q,ie,start,search_key,word,kw,cd,')
                        : 0 <= e.indexOf('yahoo.co') && (k = ',p,ei,'),
                    k && p)))
        ) {
            if ((a = p.split('&')) && 1 < a.length) {
                for (f = 0; f < a.length; f++)
                    (e = a[f]),
                        (d = e.indexOf('=')),
                        0 < d && 0 <= k.indexOf(',' + e.substring(0, d) + ',')
                            ? (n += (n ? '&' : '') + e)
                            : (q += (q ? '&' : '') + e);
                n && q ? (p = n + '&' + q) : (q = '');
            }
            d = 253 - (p.length - q.length) - b.length;
            a = b + (0 < d ? g.substring(0, d) : '') + '?' + p;
        }
        return a;
    };
    a.Wa = function (c) {
        var b = a.d.visibilityState,
            d = ['webkitvisibilitychange', 'visibilitychange'];
        b || (b = a.d.webkitVisibilityState);
        if (b && 'prerender' == b) {
            if (c)
                for (b = 0; b < d.length; b++)
                    a.d.addEventListener(d[b], function () {
                        var b = a.d.visibilityState;
                        b || (b = a.d.webkitVisibilityState);
                        'visible' == b && c();
                    });
            return !1;
        }
        return !0;
    };
    a.da = !1;
    a.I = !1;
    a.eb = function () {
        a.I = !0;
        a.j();
    };
    a.ba = !1;
    a.U = !1;
    a.$a = function (c) {
        a.marketingCloudVisitorID = c;
        a.U = !0;
        a.j();
    };
    a.ea = !1;
    a.V = !1;
    a.fb = function (c) {
        a.visitorOptedOut = c;
        a.V = !0;
        a.j();
    };
    a.Y = !1;
    a.R = !1;
    a.Sa = function (c) {
        a.analyticsVisitorID = c;
        a.R = !0;
        a.j();
    };
    a.aa = !1;
    a.T = !1;
    a.Ua = function (c) {
        a.audienceManagerLocationHint = c;
        a.T = !0;
        a.j();
    };
    a.Z = !1;
    a.S = !1;
    a.Ta = function (c) {
        a.audienceManagerBlob = c;
        a.S = !0;
        a.j();
    };
    a.Va = function (c) {
        a.maxDelay || (a.maxDelay = 250);
        return a.p('_d')
            ? (c &&
                  setTimeout(function () {
                      c();
                  }, a.maxDelay),
              !1)
            : !0;
    };
    a.ca = !1;
    a.H = !1;
    a.va = function () {
        a.H = !0;
        a.j();
    };
    a.isReadyToTrack = function () {
        var c = !0,
            b = a.visitor,
            d,
            f,
            e;
        a.da || a.I || (a.Wa(a.eb) ? (a.I = !0) : (a.da = !0));
        if (a.da && !a.I) return !1;
        b &&
            b.isAllowed() &&
            (a.ba ||
                a.marketingCloudVisitorID ||
                !b.getMarketingCloudVisitorID ||
                ((a.ba = !0),
                (a.marketingCloudVisitorID = b.getMarketingCloudVisitorID([a, a.$a])),
                a.marketingCloudVisitorID && (a.U = !0)),
            a.ea ||
                a.visitorOptedOut ||
                !b.isOptedOut ||
                ((a.ea = !0), (a.visitorOptedOut = b.isOptedOut([a, a.fb])), a.visitorOptedOut != q && (a.V = !0)),
            a.Y ||
                a.analyticsVisitorID ||
                !b.getAnalyticsVisitorID ||
                ((a.Y = !0),
                (a.analyticsVisitorID = b.getAnalyticsVisitorID([a, a.Sa])),
                a.analyticsVisitorID && (a.R = !0)),
            a.aa ||
                a.audienceManagerLocationHint ||
                !b.getAudienceManagerLocationHint ||
                ((a.aa = !0),
                (a.audienceManagerLocationHint = b.getAudienceManagerLocationHint([a, a.Ua])),
                a.audienceManagerLocationHint && (a.T = !0)),
            a.Z ||
                a.audienceManagerBlob ||
                !b.getAudienceManagerBlob ||
                ((a.Z = !0),
                (a.audienceManagerBlob = b.getAudienceManagerBlob([a, a.Ta])),
                a.audienceManagerBlob && (a.S = !0)),
            (c = a.ba && !a.U && !a.marketingCloudVisitorID),
            (b = a.Y && !a.R && !a.analyticsVisitorID),
            (d = a.aa && !a.T && !a.audienceManagerLocationHint),
            (f = a.Z && !a.S && !a.audienceManagerBlob),
            (e = a.ea && !a.V),
            (c = c || b || d || f || e ? !1 : !0));
        a.ca || a.H || (a.Va(a.va) ? (a.H = !0) : (a.ca = !0));
        a.ca && !a.H && (c = !1);
        return c;
    };
    a.o = q;
    a.u = 0;
    a.callbackWhenReadyToTrack = function (c, b, d) {
        var f;
        f = {};
        f.jb = c;
        f.ib = b;
        f.gb = d;
        a.o == q && (a.o = []);
        a.o.push(f);
        0 == a.u && (a.u = setInterval(a.j, 100));
    };
    a.j = function () {
        var c;
        if (a.isReadyToTrack() && (a.cb(), a.o != q))
            for (; 0 < a.o.length; ) (c = a.o.shift()), c.ib.apply(c.jb, c.gb);
    };
    a.cb = function () {
        a.u && (clearInterval(a.u), (a.u = 0));
    };
    a.Ya = function (c) {
        var b,
            d,
            f = q,
            e = q;
        if (!a.isReadyToTrack()) {
            b = [];
            if (c != q) for (d in ((f = {}), c)) f[d] = c[d];
            e = {};
            a.Qa(e, !0);
            b.push(f);
            b.push(e);
            a.callbackWhenReadyToTrack(a, a.track, b);
            return !0;
        }
        return !1;
    };
    a.qb = function () {
        var c = a.cookieRead('s_fid'),
            b = '',
            d = '',
            f;
        f = 8;
        var e = 4;
        if (!c || 0 > c.indexOf('-')) {
            for (c = 0; 16 > c; c++)
                (f = Math.floor(Math.random() * f)),
                    (b += '0123456789ABCDEF'.substring(f, f + 1)),
                    (f = Math.floor(Math.random() * e)),
                    (d += '0123456789ABCDEF'.substring(f, f + 1)),
                    (f = e = 16);
            c = b + '-' + d;
        }
        a.cookieWrite('s_fid', c, 1) || (c = 0);
        return c;
    };
    a.t = a.track = function (c, b) {
        var d,
            f = new Date(),
            e = 's' + (Math.floor(f.getTime() / 108e5) % 10) + Math.floor(1e13 * Math.random()),
            g = f.getYear(),
            g =
                't=' +
                a.escape(
                    f.getDate() +
                        '/' +
                        f.getMonth() +
                        '/' +
                        (1900 > g ? g + 1900 : g) +
                        ' ' +
                        f.getHours() +
                        ':' +
                        f.getMinutes() +
                        ':' +
                        f.getSeconds() +
                        ' ' +
                        f.getDay() +
                        ' ' +
                        f.getTimezoneOffset(),
                );
        a.visitor &&
            (a.visitor.getAuthState && (a.authState = a.visitor.getAuthState()),
            !a.supplementalDataID &&
                a.visitor.getSupplementalDataID &&
                (a.supplementalDataID = a.visitor.getSupplementalDataID(
                    'AppMeasurement:' + a._in,
                    a.expectSupplementalData ? !1 : !0,
                )));
        a.p('_s');
        a.Ya(c) ||
            (b && a.Q(b),
            c && ((d = {}), a.Qa(d, 0), a.Q(c)),
            a.wb() &&
                !a.visitorOptedOut &&
                (a.analyticsVisitorID || a.marketingCloudVisitorID || (a.fid = a.qb()),
                a.Bb(),
                a.usePlugins && a.doPlugins && a.doPlugins(a),
                a.account &&
                    (a.abort ||
                        (a.trackOffline && !a.timestamp && (a.timestamp = Math.floor(f.getTime() / 1e3)),
                        (f = k.location),
                        a.pageURL || (a.pageURL = f.href ? f.href : f),
                        a.referrer || a.Ra || (a.referrer = r.document.referrer),
                        (a.Ra = 1),
                        (a.referrer = a.ob(a.referrer)),
                        a.p('_g')),
                    a.tb() && !a.abort && (a.ub(), (g += a.sb()), a.Ab(e, g), a.p('_t'), (a.referrer = '')))),
            c && a.Q(d, 1));
        a.abort =
            a.supplementalDataID =
            a.timestamp =
            a.pageURLRest =
            a.linkObject =
            a.clickObject =
            a.linkURL =
            a.linkName =
            a.linkType =
            k.s_objectID =
            a.pe =
            a.pev1 =
            a.pev2 =
            a.pev3 =
            a.e =
            a.lightProfileID =
                0;
    };
    a.tl = a.trackLink = function (c, b, d, f, e) {
        a.linkObject = c;
        a.linkType = b;
        a.linkName = d;
        e && ((a.l = c), (a.A = e));
        return a.track(f);
    };
    a.trackLight = function (c, b, d, f) {
        a.lightProfileID = c;
        a.lightStoreForSeconds = b;
        a.lightIncrementBy = d;
        return a.track(f);
    };
    a.clearVars = function () {
        var c, b;
        for (c = 0; c < a.g.length; c++)
            if (
                ((b = a.g[c]),
                'prop' == b.substring(0, 4) ||
                    'eVar' == b.substring(0, 4) ||
                    'hier' == b.substring(0, 4) ||
                    'list' == b.substring(0, 4) ||
                    'channel' == b ||
                    'events' == b ||
                    'eventList' == b ||
                    'products' == b ||
                    'productList' == b ||
                    'purchaseID' == b ||
                    'transactionID' == b ||
                    'state' == b ||
                    'zip' == b ||
                    'campaign' == b)
            )
                a[b] = void 0;
    };
    a.tagContainerMarker = '';
    a.Ab = function (c, b) {
        var d,
            f = a.trackingServer;
        d = '';
        var e = a.dc,
            g = 'sc.',
            k = a.visitorNamespace;
        f
            ? a.trackingServerSecure && a.ssl && (f = a.trackingServerSecure)
            : (k ||
                  ((k = a.account),
                  (f = k.indexOf(',')),
                  0 <= f && (k = k.substring(0, f)),
                  (k = k.replace(/[^A-Za-z0-9]/g, ''))),
              d || (d = '2o7.net'),
              (e = e ? ('' + e).toLowerCase() : 'd1'),
              '2o7.net' == d && ('d1' == e ? (e = '112') : 'd2' == e && (e = '122'), (g = '')),
              (f = k + '.' + e + '.' + g + d));
        d = a.ssl ? 'https://' : 'http://';
        e = (a.AudienceManagement && a.AudienceManagement.isReady()) || 0 != a.usePostbacks;
        d +=
            f +
            '/b/ss/' +
            a.account +
            '/' +
            (a.mobile ? '5.' : '') +
            (e ? '10' : '1') +
            '/JS-' +
            a.version +
            (a.Eb ? 'T' : '') +
            (a.tagContainerMarker ? '-' + a.tagContainerMarker : '') +
            '/' +
            c +
            '?AQB=1&ndh=1&pf=1&' +
            (e ? 'callback=s_c_il[' + a._in + '].doPostbacks&et=1&' : '') +
            b +
            '&AQE=1';
        a.mb(d);
        a.ja();
    };
    a.Pa = /{(%?)(.*?)(%?)}/;
    a.Ib = RegExp(a.Pa.source, 'g');
    a.nb = function (c) {
        if ('object' == typeof c.dests)
            for (var b = 0; b < c.dests.length; ++b)
                if (((o = c.dests[b]), 'string' == typeof o.c && 'aa.' == o.id.substr(0, 3)))
                    for (var d = o.c.match(a.Ib), b = 0; b < d.length; ++b) {
                        match = d[b];
                        var f = match.match(a.Pa),
                            e = '';
                        '%' == f[1] && 'timezone_offset' == f[2]
                            ? (e = new Date().getTimezoneOffset())
                            : '%' == f[1] && 'timestampz' == f[2] && (e = a.rb());
                        o.c = o.c.replace(match, a.escape(e));
                    }
    };
    a.rb = function () {
        var c = new Date(),
            b = new Date(6e4 * Math.abs(c.getTimezoneOffset()));
        return (
            a.k(4, c.getFullYear()) +
            '-' +
            a.k(2, c.getMonth() + 1) +
            '-' +
            a.k(2, c.getDate()) +
            'T' +
            a.k(2, c.getHours()) +
            ':' +
            a.k(2, c.getMinutes()) +
            ':' +
            a.k(2, c.getSeconds()) +
            (0 < c.getTimezoneOffset() ? '-' : '+') +
            a.k(2, b.getUTCHours()) +
            ':' +
            a.k(2, b.getUTCMinutes())
        );
    };
    a.k = function (a, b) {
        return (Array(a + 1).join(0) + b).slice(-a);
    };
    a.ra = {};
    a.doPostbacks = function (c) {
        if ('object' == typeof c)
            if (
                (a.nb(c),
                'object' == typeof a.AudienceManagement &&
                    'function' == typeof a.AudienceManagement.isReady &&
                    a.AudienceManagement.isReady() &&
                    'function' == typeof a.AudienceManagement.passData)
            )
                a.AudienceManagement.passData(c);
            else if ('object' == typeof c && 'object' == typeof c.dests)
                for (var b = 0; b < c.dests.length; ++b)
                    (dest = c.dests[b]),
                        'object' == typeof dest &&
                            'string' == typeof dest.c &&
                            'string' == typeof dest.id &&
                            'aa.' == dest.id.substr(0, 3) &&
                            ((a.ra[dest.id] = new Image()), (a.ra[dest.id].alt = ''), (a.ra[dest.id].src = dest.c));
    };
    a.mb = function (c) {
        a.i || a.vb();
        a.i.push(c);
        a.la = a.C();
        a.Na();
    };
    a.vb = function () {
        a.i = a.xb();
        a.i || (a.i = []);
    };
    a.xb = function () {
        var c, b;
        if (a.qa()) {
            try {
                (b = k.localStorage.getItem(a.oa())) && (c = k.JSON.parse(b));
            } catch (d) {}
            return c;
        }
    };
    a.qa = function () {
        var c = !0;
        (a.trackOffline && a.offlineFilename && k.localStorage && k.JSON) || (c = !1);
        return c;
    };
    a.Ea = function () {
        var c = 0;
        a.i && (c = a.i.length);
        a.q && c++;
        return c;
    };
    a.ja = function () {
        if (a.q && (a.B && a.B.complete && a.B.F && a.B.ua(), a.q)) return;
        a.Fa = q;
        if (a.pa) a.la > a.N && a.La(a.i), a.ta(500);
        else {
            var c = a.hb();
            if (0 < c) a.ta(c);
            else if ((c = a.Ba())) (a.q = 1), a.zb(c), a.Db(c);
        }
    };
    a.ta = function (c) {
        a.Fa || (c || (c = 0), (a.Fa = setTimeout(a.ja, c)));
    };
    a.hb = function () {
        var c;
        if (!a.trackOffline || 0 >= a.offlineThrottleDelay) return 0;
        c = a.C() - a.Ka;
        return a.offlineThrottleDelay < c ? 0 : a.offlineThrottleDelay - c;
    };
    a.Ba = function () {
        if (0 < a.i.length) return a.i.shift();
    };
    a.zb = function (c) {
        if (a.debugTracking) {
            var b = 'AppMeasurement Debug: ' + c;
            c = c.split('&');
            var d;
            for (d = 0; d < c.length; d++) b += '\n\t' + a.unescape(c[d]);
            a.yb(b);
        }
    };
    a.Za = function () {
        return a.marketingCloudVisitorID || a.analyticsVisitorID;
    };
    a.X = !1;
    var s;
    try {
        s = JSON.parse('{"x":"y"}');
    } catch (x) {
        s = null;
    }
    s && 'y' == s.x
        ? ((a.X = !0),
          (a.W = function (a) {
              return JSON.parse(a);
          }))
        : k.$ && k.$.parseJSON
          ? ((a.W = function (a) {
                return k.$.parseJSON(a);
            }),
            (a.X = !0))
          : (a.W = function () {
                return null;
            });
    a.Db = function (c) {
        var b, d, f;
        a.Za() &&
            2047 < c.length &&
            ('undefined' != typeof XMLHttpRequest &&
                ((b = new XMLHttpRequest()), 'withCredentials' in b ? (d = 1) : (b = 0)),
            b || 'undefined' == typeof XDomainRequest || ((b = new XDomainRequest()), (d = 2)),
            b &&
                ((a.AudienceManagement && a.AudienceManagement.isReady()) || 0 != a.usePostbacks) &&
                (a.X ? (b.xa = !0) : (b = 0)));
        !b && a.Oa && (c = c.substring(0, 2047));
        !b &&
            a.d.createElement &&
            (0 != a.usePostbacks || (a.AudienceManagement && a.AudienceManagement.isReady())) &&
            (b = a.d.createElement('SCRIPT')) &&
            'async' in b &&
            ((f = (f = a.d.getElementsByTagName('HEAD')) && f[0] ? f[0] : a.d.body)
                ? ((b.type = 'text/javascript'), b.setAttribute('async', 'async'), (d = 3))
                : (b = 0));
        b ||
            ((b = new Image()),
            (b.alt = ''),
            b.abort ||
                'undefined' === typeof k.InstallTrigger ||
                (b.abort = function () {
                    b.src = q;
                }));
        b.za = function () {
            try {
                b.F && (clearTimeout(b.F), (b.F = 0));
            } catch (a) {}
        };
        b.onload = b.ua = function () {
            b.za();
            a.lb();
            a.fa();
            a.q = 0;
            a.ja();
            if (b.xa) {
                b.xa = !1;
                try {
                    a.doPostbacks(a.W(b.responseText));
                } catch (c) {}
            }
        };
        b.onabort =
            b.onerror =
            b.Ca =
                function () {
                    b.za();
                    (a.trackOffline || a.pa) && a.q && a.i.unshift(a.kb);
                    a.q = 0;
                    a.la > a.N && a.La(a.i);
                    a.fa();
                    a.ta(500);
                };
        b.onreadystatechange = function () {
            4 == b.readyState && (200 == b.status ? b.ua() : b.Ca());
        };
        a.Ka = a.C();
        if (1 == d || 2 == d) {
            var e = c.indexOf('?');
            f = c.substring(0, e);
            e = c.substring(e + 1);
            e = e.replace(/&callback=[a-zA-Z0-9_.\[\]]+/, '');
            1 == d ? (b.open('POST', f, !0), b.send(e)) : 2 == d && (b.open('POST', f), b.send(e));
        } else if (((b.src = c), 3 == d)) {
            if (a.Ia)
                try {
                    f.removeChild(a.Ia);
                } catch (g) {}
            f.firstChild ? f.insertBefore(b, f.firstChild) : f.appendChild(b);
            a.Ia = a.B;
        }
        b.F = setTimeout(function () {
            b.F && (b.complete ? b.ua() : (a.trackOffline && b.abort && b.abort(), b.Ca()));
        }, 5e3);
        a.kb = c;
        a.B = k['s_i_' + a.replace(a.account, ',', '_')] = b;
        if ((a.useForcedLinkTracking && a.J) || a.A)
            a.forcedLinkTrackingTimeout || (a.forcedLinkTrackingTimeout = 250),
                (a.ga = setTimeout(a.fa, a.forcedLinkTrackingTimeout));
    };
    a.lb = function () {
        if (a.qa() && !(a.Ja > a.N))
            try {
                k.localStorage.removeItem(a.oa()), (a.Ja = a.C());
            } catch (c) {}
    };
    a.La = function (c) {
        if (a.qa()) {
            a.Na();
            try {
                k.localStorage.setItem(a.oa(), k.JSON.stringify(c)), (a.N = a.C());
            } catch (b) {}
        }
    };
    a.Na = function () {
        if (a.trackOffline) {
            if (!a.offlineLimit || 0 >= a.offlineLimit) a.offlineLimit = 10;
            for (; a.i.length > a.offlineLimit; ) a.Ba();
        }
    };
    a.forceOffline = function () {
        a.pa = !0;
    };
    a.forceOnline = function () {
        a.pa = !1;
    };
    a.oa = function () {
        return a.offlineFilename + '-' + a.visitorNamespace + a.account;
    };
    a.C = function () {
        return new Date().getTime();
    };
    a.Ga = function (a) {
        a = a.toLowerCase();
        return 0 != a.indexOf('#') &&
            0 != a.indexOf('about:') &&
            0 != a.indexOf('opera:') &&
            0 != a.indexOf('javascript:')
            ? !0
            : !1;
    };
    a.setTagContainer = function (c) {
        var b, d, f;
        a.Eb = c;
        for (b = 0; b < a._il.length; b++)
            if ((d = a._il[b]) && 's_l' == d._c && d.tagContainerName == c) {
                a.Q(d);
                if (d.lmq) for (b = 0; b < d.lmq.length; b++) (f = d.lmq[b]), a.loadModule(f.n);
                if (d.ml)
                    for (f in d.ml)
                        if (a[f])
                            for (b in ((c = a[f]), (f = d.ml[f]), f))
                                !Object.prototype[b] &&
                                    ('function' != typeof f[b] || 0 > ('' + f[b]).indexOf('s_c_il')) &&
                                    (c[b] = f[b]);
                if (d.mmq)
                    for (b = 0; b < d.mmq.length; b++)
                        (f = d.mmq[b]),
                            a[f.m] &&
                                ((c = a[f.m]),
                                c[f.f] &&
                                    'function' == typeof c[f.f] &&
                                    (f.a ? c[f.f].apply(c, f.a) : c[f.f].apply(c)));
                if (d.tq) for (b = 0; b < d.tq.length; b++) a.track(d.tq[b]);
                d.s = a;
                break;
            }
    };
    a.Util = {
        urlEncode: a.escape,
        urlDecode: a.unescape,
        cookieRead: a.cookieRead,
        cookieWrite: a.cookieWrite,
        getQueryParam: function (c, b, d) {
            var f;
            b || (b = a.pageURL ? a.pageURL : k.location);
            d || (d = '&');
            return c &&
                b &&
                ((b = '' + b),
                (f = b.indexOf('?')),
                0 <= f &&
                    ((b = d + b.substring(f + 1) + d),
                    (f = b.indexOf(d + c + '=')),
                    0 <= f &&
                        ((b = b.substring(f + d.length + c.length + 1)),
                        (f = b.indexOf(d)),
                        0 <= f && (b = b.substring(0, f)),
                        0 < b.length)))
                ? a.unescape(b)
                : '';
        },
    };
    a.G =
        'supplementalDataID timestamp dynamicVariablePrefix visitorID marketingCloudVisitorID analyticsVisitorID audienceManagerLocationHint authState fid vmk visitorMigrationKey visitorMigrationServer visitorMigrationServerSecure charSet visitorNamespace cookieDomainPeriods fpCookieDomainPeriods cookieLifetime pageName pageURL referrer contextData currencyCode lightProfileID lightStoreForSeconds lightIncrementBy retrieveLightProfiles deleteLightProfiles retrieveLightData'.split(
            ' ',
        );
    a.g = a.G.concat(
        'purchaseID variableProvider channel server pageType transactionID campaign state zip events events2 products audienceManagerBlob tnt'.split(
            ' ',
        ),
    );
    a.ma =
        'timestamp charSet visitorNamespace cookieDomainPeriods cookieLifetime contextData lightProfileID lightStoreForSeconds lightIncrementBy'.split(
            ' ',
        );
    a.O = a.ma.slice(0);
    a.wa =
        'account allAccounts debugTracking visitor visitorOptedOut trackOffline offlineLimit offlineThrottleDelay offlineFilename usePlugins doPlugins configURL visitorSampling visitorSamplingGroup linkObject clickObject linkURL linkName linkType trackDownloadLinks trackExternalLinks trackClickMap trackInlineStats linkLeaveQueryString linkTrackVars linkTrackEvents linkDownloadFileTypes linkExternalFilters linkInternalFilters useForcedLinkTracking forcedLinkTrackingTimeout trackingServer trackingServerSecure ssl abort mobile dc lightTrackVars maxDelay expectSupplementalData usePostbacks AudienceManagement'.split(
            ' ',
        );
    for (n = 0; 250 >= n; n++)
        76 > n && (a.g.push('prop' + n), a.O.push('prop' + n)),
            a.g.push('eVar' + n),
            a.O.push('eVar' + n),
            6 > n && a.g.push('hier' + n),
            4 > n && a.g.push('list' + n);
    n =
        'pe pev1 pev2 pev3 latitude longitude resolution colorDepth javascriptVersion javaEnabled cookiesEnabled browserWidth browserHeight connectionType homepage pageURLRest'.split(
            ' ',
        );
    a.g = a.g.concat(n);
    a.G = a.G.concat(n);
    a.ssl = 0 <= k.location.protocol.toLowerCase().indexOf('https');
    a.charSet = 'UTF-8';
    a.contextData = {};
    a.offlineThrottleDelay = 0;
    a.offlineFilename = 'AppMeasurement.offline';
    a.Ka = 0;
    a.la = 0;
    a.N = 0;
    a.Ja = 0;
    a.linkDownloadFileTypes = 'exe,zip,wav,mp3,mov,mpg,avi,wmv,pdf,doc,docx,xls,xlsx,ppt,pptx';
    a.w = k;
    a.d = k.document;
    try {
        if (((a.Oa = !1), navigator)) {
            var y = navigator.userAgent;
            if (
                'Microsoft Internet Explorer' == navigator.appName ||
                0 <= y.indexOf('MSIE ') ||
                (0 <= y.indexOf('Trident/') && 0 <= y.indexOf('Windows NT 6'))
            )
                a.Oa = !0;
        }
    } catch (z) {}
    a.fa = function () {
        a.ga && (k.clearTimeout(a.ga), (a.ga = q));
        a.l && a.J && a.l.dispatchEvent(a.J);
        a.A && ('function' == typeof a.A ? a.A() : a.l && a.l.href && (a.d.location = a.l.href));
        a.l = a.J = a.A = 0;
    };
    a.Ma = function () {
        a.b = a.d.body;
        a.b
            ? ((a.v = function (c) {
                  var b, d, f, e, g;
                  if (!((a.d && a.d.getElementById('cppXYctnr')) || (c && c['s_fe_' + a._in]))) {
                      if (a.ya)
                          if (a.useForcedLinkTracking) a.b.removeEventListener('click', a.v, !1);
                          else {
                              a.b.removeEventListener('click', a.v, !0);
                              a.ya = a.useForcedLinkTracking = 0;
                              return;
                          }
                      else a.useForcedLinkTracking = 0;
                      a.clickObject = c.srcElement ? c.srcElement : c.target;
                      try {
                          if (
                              !a.clickObject ||
                              (a.M && a.M == a.clickObject) ||
                              !(a.clickObject.tagName || a.clickObject.parentElement || a.clickObject.parentNode)
                          )
                              a.clickObject = 0;
                          else {
                              var m = (a.M = a.clickObject);
                              a.ka && (clearTimeout(a.ka), (a.ka = 0));
                              a.ka = setTimeout(function () {
                                  a.M == m && (a.M = 0);
                              }, 1e4);
                              f = a.Ea();
                              a.track();
                              if (f < a.Ea() && a.useForcedLinkTracking && c.target) {
                                  for (
                                      e = c.target;
                                      e &&
                                      e != a.b &&
                                      'A' != e.tagName.toUpperCase() &&
                                      'AREA' != e.tagName.toUpperCase();

                                  )
                                      e = e.parentNode;
                                  if (
                                      e &&
                                      ((g = e.href),
                                      a.Ga(g) || (g = 0),
                                      (d = e.target),
                                      c.target.dispatchEvent &&
                                          g &&
                                          (!d ||
                                              '_self' == d ||
                                              '_top' == d ||
                                              '_parent' == d ||
                                              (k.name && d == k.name)))
                                  ) {
                                      try {
                                          b = a.d.createEvent('MouseEvents');
                                      } catch (n) {
                                          b = new k.MouseEvent();
                                      }
                                      if (b) {
                                          try {
                                              b.initMouseEvent(
                                                  'click',
                                                  c.bubbles,
                                                  c.cancelable,
                                                  c.view,
                                                  c.detail,
                                                  c.screenX,
                                                  c.screenY,
                                                  c.clientX,
                                                  c.clientY,
                                                  c.ctrlKey,
                                                  c.altKey,
                                                  c.shiftKey,
                                                  c.metaKey,
                                                  c.button,
                                                  c.relatedTarget,
                                              );
                                          } catch (q) {
                                              b = 0;
                                          }
                                          b &&
                                              ((b['s_fe_' + a._in] = b.s_fe = 1),
                                              c.stopPropagation(),
                                              c.stopImmediatePropagation && c.stopImmediatePropagation(),
                                              c.preventDefault(),
                                              (a.l = c.target),
                                              (a.J = b));
                                      }
                                  }
                              }
                          }
                      } catch (r) {
                          a.clickObject = 0;
                      }
                  }
              }),
              a.b && a.b.attachEvent
                  ? a.b.attachEvent('onclick', a.v)
                  : a.b &&
                    a.b.addEventListener &&
                    (navigator &&
                        ((0 <= navigator.userAgent.indexOf('WebKit') && a.d.createEvent) ||
                            (0 <= navigator.userAgent.indexOf('Firefox/2') && k.MouseEvent)) &&
                        ((a.ya = 1), (a.useForcedLinkTracking = 1), a.b.addEventListener('click', a.v, !0)),
                    a.b.addEventListener('click', a.v, !1)))
            : setTimeout(a.Ma, 30);
    };
    a.Ma();
    a.loadModule('ActivityMap');
};
window.s_gi = function (a) {
    var k,
        q = window.s_c_il,
        r,
        n,
        t = a.split(','),
        u,
        s,
        x = 0;
    if (q)
        for (r = 0; !x && r < q.length; ) {
            k = q[r];
            if ('s_c' == k._c && (k.account || k.oun))
                if (k.account && k.account == a) x = 1;
                else
                    for (
                        n = k.account ? k.account : k.oun, n = k.allAccounts ? k.allAccounts : n.split(','), u = 0;
                        u < t.length;
                        u++
                    )
                        for (s = 0; s < n.length; s++) t[u] == n[s] && (x = 1);
            r++;
        }
    x || (k = new AppMeasurement());
    k.setAccount ? k.setAccount(a) : k.sa && k.sa(a);
    return k;
};
AppMeasurement.getInstance = s_gi;
window.s_objectID || (window.s_objectID = 0);
window.s_pgicq = function () {
    var a = window,
        k = a.s_giq,
        q,
        r,
        n;
    if (k)
        for (q = 0; q < k.length; q++)
            (r = k[q]), (n = s_gi(r.oun)), n.setAccount(r.un), n.setTagContainer(r.tagContainerName);
    a.s_giq = 0;
};
s_pgicq();
/*
 ============== DO NOT ALTER ANYTHING ABOVE THIS LINE ! ===============
 */

//initialize AppMeasurement
window.s_account = 'nhlglobal15,nhlcom15';
window.s = s_gi(s_account);

/******** VISITOR ID SERVICE CONFIG - REQUIRES VisitorAPI.js ********/
s.visitor = Visitor.getInstance('25823F955A99D5040A495C1D@AdobeOrg');

/************************** CONFIG SECTION **************************/
/* You may add or alter any code config here. */
/* Link Tracking Config */
s.trackDownloadLinks = true;
s.trackExternalLinks = true;
s.trackInlineStats = true;
s.linkDownloadFileTypes = 'exe,zip,wav,mp3,mov,mpg,avi,wmv,pdf,doc,docx,xls,xlsx,ppt,pptx';
s.linkInternalFilters = 'javascript:,nhl.com'; //optional: add your internal domain here
s.linkLeaveQueryString = false;
s.linkTrackVars = 'None';
s.linkTrackEvents = 'None';

//helper func to scrape query params out of the URL
window.getQParam = function (b) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] == b) {
            return pair[1];
        }
    }
    return false;
};

s.trackingServer = 'Bamtech.sc.omtrdc.net';
s.trackingServerSecure = 'Bamtech.sc.omtrdc.net';
/*
 Start ActivityMap Module

 The following module enables ActivityMap tracking in Adobe Analytics. ActivityMap
 allows you to view data overlays on your links and content to understand how
 users engage with your web site. If you do not intend to use ActivityMap, you
 can remove the following block of code from your AppMeasurement.js file.
 Additional documentation on how to configure ActivityMap is available at:
 https://marketing.adobe.com/resources/help/en_US/analytics/activitymap/getting-started-admins.html
*/
window.AppMeasurement_Module_ActivityMap = function (f) {
    function g(a, d) {
        var b, c, n;
        if (a && d && (b = e.c[d] || (e.c[d] = d.split(','))))
            for (n = 0; n < b.length && (c = b[n++]); ) if (-1 < a.indexOf(c)) return null;
        p = 1;
        return a;
    }
    function q(a, d, b, c, e) {
        var g, h;
        if (a.dataset && (h = a.dataset[d])) g = h;
        else if (a.getAttribute)
            if ((h = a.getAttribute('data-' + b))) g = h;
            else if ((h = a.getAttribute(b))) g = h;
        if (!g && f.useForcedLinkTracking && e && ((g = ''), (d = a.onclick ? '' + a.onclick : ''))) {
            b = d.indexOf(c);
            var l, k;
            if (0 <= b) {
                for (b += 10; b < d.length && 0 <= '= \t\r\n'.indexOf(d.charAt(b)); ) b++;
                if (b < d.length) {
                    h = b;
                    for (l = k = 0; h < d.length && (';' != d.charAt(h) || l); )
                        l
                            ? d.charAt(h) != l || k
                                ? (k = '\\' == d.charAt(h) ? !k : 0)
                                : (l = 0)
                            : ((l = d.charAt(h)), '"' != l && "'" != l && (l = 0)),
                            h++;
                    if ((d = d.substring(b, h)))
                        (a.e = new Function('s', 'var e;try{s.w.' + c + '=' + d + '}catch(e){}')), a.e(f);
                }
            }
        }
        return g || (e && f.w[c]);
    }
    function r(a, d, b) {
        var c;
        return (c = e[d](a, b)) && (p ? ((p = 0), c) : g(k(c), e[d + 'Exclusions']));
    }
    function s(a, d, b) {
        var c;
        if (
            a &&
            !(1 === (c = a.nodeType) && (c = a.nodeName) && (c = c.toUpperCase()) && t[c]) &&
            (1 === a.nodeType && (c = a.nodeValue) && (d[d.length] = c),
            b.a ||
                b.t ||
                b.s ||
                !a.getAttribute ||
                ((c = a.getAttribute('alt'))
                    ? (b.a = c)
                    : (c = a.getAttribute('title'))
                      ? (b.t = c)
                      : 'IMG' == ('' + a.nodeName).toUpperCase() && (c = a.getAttribute('src') || a.src) && (b.s = c)),
            (c = a.childNodes) && c.length)
        )
            for (a = 0; a < c.length; a++) s(c[a], d, b);
    }
    function k(a) {
        if (null == a || void 0 == a) return a;
        try {
            return a
                .replace(
                    RegExp(
                        '^[\\s\\n\\f\\r\\t\t-\r \u00a0\u1680\u180e\u2000-\u200a\u2028\u2029\u205f\u3000\ufeff]+',
                        'mg',
                    ),
                    '',
                )
                .replace(
                    RegExp(
                        '[\\s\\n\\f\\r\\t\t-\r \u00a0\u1680\u180e\u2000-\u200a\u2028\u2029\u205f\u3000\ufeff]+$',
                        'mg',
                    ),
                    '',
                )
                .replace(
                    RegExp(
                        '[\\s\\n\\f\\r\\t\t-\r \u00a0\u1680\u180e\u2000-\u200a\u2028\u2029\u205f\u3000\ufeff]{1,}',
                        'mg',
                    ),
                    ' ',
                )
                .substring(0, 254);
        } catch (d) {}
    }
    var e = this;
    e.s = f;
    var m = window;
    m.s_c_in || ((m.s_c_il = []), (m.s_c_in = 0));
    e._il = m.s_c_il;
    e._in = m.s_c_in;
    e._il[e._in] = e;
    m.s_c_in++;
    e._c = 's_m';
    e.c = {};
    var p = 0,
        t = { SCRIPT: 1, STYLE: 1, LINK: 1, CANVAS: 1 };
    e._g = function () {
        var a,
            d,
            b,
            c = f.contextData,
            e = f.linkObject;
        (a = f.pageName || f.pageURL) &&
            (d = r(e, 'link', f.linkName)) &&
            (b = r(e, 'region')) &&
            ((c['a.activitymap.page'] = a.substring(0, 255)),
            (c['a.activitymap.link'] = 128 < d.length ? d.substring(0, 128) : d),
            (c['a.activitymap.region'] = 127 < b.length ? b.substring(0, 127) : b),
            (c['a.activitymap.pageIDType'] = f.pageName ? 1 : 0));
    };
    e.link = function (a, d) {
        var b;
        if (d) b = g(k(d), e.linkExclusions);
        else if ((b = a) && !(b = q(a, 'sObjectId', 's-object-id', 's_objectID', 1))) {
            var c, f;
            (f = g(k(a.innerText || a.textContent), e.linkExclusions)) ||
                (s(a, (c = []), (b = { a: void 0, t: void 0, s: void 0 })),
                (f = g(k(c.join('')))) ||
                    (f = g(k(b.a ? b.a : b.t ? b.t : b.s ? b.s : void 0))) ||
                    !(c = (c = a.tagName) && c.toUpperCase ? c.toUpperCase() : '') ||
                    ('INPUT' == c || ('SUBMIT' == c && a.value)
                        ? (f = g(k(a.value)))
                        : 'IMAGE' == c && a.src && (f = g(k(a.src)))));
            b = f;
        }
        return b;
    };
    e.region = function (a) {
        for (var d, b = e.regionIDAttribute || 'id'; a && (a = a.parentNode); ) {
            if ((d = q(a, b, b, b))) return d;
            if ('BODY' == a.nodeName) return 'BODY';
        }
    };
};
/* End ActivityMap Module */
